import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getPayments(params: any): AxiosPromise {
    return EndPointService.get('/payments', { params });
}

function getPayment(id: number | string): AxiosPromise {
    return EndPointService.get(`/payments/${id}`);
}

function deletePayment(id: number | string): AxiosPromise {
    return EndPointService.delete(`/payments/${id}`);
}

function createPayment(payload: any): AxiosPromise {
    return EndPointService.post('/payments', payload);
}

function updatePayment(id: number | string, payload: any): AxiosPromise {
    delete payload.id;
    return EndPointService.put(`/payments/${id}`, { ...payload });
}

function patchPayment(payload: any): AxiosPromise {
    return EndPointService.put(`/payment/status`, payload);
}

export default {
    getPayments,
    getPayment,
    deletePayment,
    createPayment,
    updatePayment,
    patchPayment,
};
